import { defineStore } from "pinia";

export const uiStore = defineStore("ui", {
	id: "ui",
	state: () => ({
		currentBreakPoint: '',
    previousBreakPoint: '',
    breakPointList: [ 'xs', 'sm', 'md', 'lg', 'xl' ], 
		sidePanelShow: false,
	}),

	getters: {
    breakPoint: state => (bp, condition) => {
      if (!bp) {
        return state.currentBreakPoint
      } else {
        if (!condition) return bp === state.currentBreakPoint
        const bpIndex = state.breakPointList.findIndex(el => el === bp)
        const currentBpIndex = state.breakPointList.findIndex(el => el === state.currentBreakPoint)
        if (condition === 'gt') return currentBpIndex > bpIndex 
        if (condition === 'gte') return currentBpIndex >= bpIndex
        if (condition === 'lt') return currentBpIndex < bpIndex 
        if (condition === 'lte') return currentBpIndex <= bpIndex
      } 
    },
    breakPointIndex: state => state.breakPointList.findIndex(el => el === state.currentBreakPoint) + 1
	},

  actions: {
    setBreakPoint(breakPoint) {
      this.previousBreakPoint = this.currentBreakPoint;  
      this.currentBreakPoint = breakPoint;    
    },
    
  },
});

